// index.js
import fr from './fr.json'
import nl from './nl.json'

export const defaultLocale = 'fr'

export const languages = {
  fr: fr,
  nl: nl
}


// WEBPACK FOOTER //
// ./src/locales/index.js